<template>
  <div class="digital-certificate-jump"></div>
</template>

<script>
export default {
  name: 'DigitalCertificateJump',
  created() {
    window.parent.postMessage({
      type: '已阅读同意',
    }, '*');
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">

</style>
